import { Component, OnInit, Input } from '@angular/core';
import { AuthService } from 'src/app/core/services/authentication.service';
import * as _ from "lodash";
import { Global } from 'src/app/core/resources/global';
import { ManualCreationCargoService } from 'src/app/modules/cargo/manual-creation-cargo/manual-creation-cargo.service';
import { Router } from '@angular/router';
import { SnackBarService } from 'src/app/core/services/snackBar.service';
import { Fmt } from 'src/app/core/messages/fmt';
import { FormMessages } from 'src/app/core/messages/form-messages.enum';
import { FormControl, Validators } from '@angular/forms';
import { Utils } from 'src/app/core/resources/utils';
import { delay } from 'rxjs/operators';

@Component({
  selector: 'app-method-payment',
  templateUrl: './method-payment.component.html',
  styleUrls: ['./method-payment.component.scss'],
  providers: [AuthService, Global]
})
export class MethodPaymentComponent {
  minLengthObservation: number = 3;
  constructor(
    public manualCreationCargoService: ManualCreationCargoService,
    private router: Router,
    private authService: AuthService,
    public snackBarService: SnackBarService,
    public utils: Utils
  ) { }

  nextStep() {
    this.manualCreationCargoService.getComponentActive().setId(4);
    this.manualCreationCargoService.getComponentActive().getStep().setId(3);
    this.router.navigate([this.manualCreationCargoService.steps.totalValue.url]);
  }

  stepBack() {
    this.manualCreationCargoService.getComponentActive().setId(4);
    this.manualCreationCargoService.getComponentActive().getStep().setId(1);
    this.router.navigate([this.manualCreationCargoService.steps.cargoValue.url]);
  }

}
